export default __webpack_public_path__ + "images/475663a365f3536e8ece1fd9f0f5d15a.png";